var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCalendarLeftArrowIcon = function SvgCalendarLeftArrowIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45,
    height: 45,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    r: 22.5,
    transform: "matrix(-1 0 0 1 22.5 22.5)",
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.607 27.701 21.4 22.493l5.208-5.208a1.337 1.337 0 0 0 0-1.892 1.337 1.337 0 0 0-1.892 0l-6.161 6.16a1.337 1.337 0 0 0 0 1.893l6.16 6.161c.524.524 1.37.524 1.893 0 .51-.523.524-1.382 0-1.906Z",
    fill: "#164B84"
  })));
};
export default SvgCalendarLeftArrowIcon;